/* eslint-disable import/extensions */
import { baseErrorHandler } from '@queries/baseErrorHandler';
import i18n from '@service/I18nService';
import { $api } from '@service/RequestService';
import { getOrdersBody } from '@utils/helper/getSearchAndDownloadBodyAllTables';
import { useMutation } from 'react-query';

import { SearchParamsOrder } from '../Order';
import { endPoints } from '../utils/constants/endPoints';

export function useDownloadOrdersToExcel(size: number, searchObj: SearchParamsOrder) {
  return useMutation(
    async () => {
      const res = await $api.post(
        `${endPoints.BOOKING_FILTER_EXCEL}?lang=${i18n.language?.toUpperCase()}`,
        getOrdersBody(searchObj),
        {
          responseType: 'blob'
        }
      );

      return res.data;
    },
    {
      onError: baseErrorHandler
    }
  );
}
